import React, { useEffect, useRef, useState } from 'react';
import { Box, ButtonBase, makeStyles, Typography } from '@material-ui/core';
import ROUTES from 'src/lib/routes';
import useRouter from 'src/hooks/useRouter';
import { isListEnabled } from 'src/lib/api-client/lists';
import { useQuery } from 'react-query';
import { IconBack } from 'src/components/Icons';
import { Heading } from 'src/components/UI';
import COLORS from 'src/lib/colors';
import ShippingQuoteEstimator from './shipping-quote-estimator';
import ShippingRateDelivery from './shipping-rate-delivery';

const useStyles = makeStyles(() => ({
    QuoteShippingContainer: {
        overflowY: 'hidden',
        height: '100vh',
        background: COLORS.primaryWhite,
    },
    QuoteShippingHeader: {
        height: '60px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '15px',
        justifyContent: 'center',
        position: 'sticky',
        zIndex: 1,
        marginTop: '1rem',
    },
    startCreate: {
        height: '30px',
        width: '166px',
        borderRadius: '20px',
        background: '#CC0000',
        marginBottom: '24px',
        '& span': {
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '11.8px',
            color: '#FFFFFF',
            textAlign: 'center',
        },
    },
    QuoteShippingHeaderImgTextAlign: {
        display: 'flex',
        position: 'relative',
        width: '100%',
        alignItems: 'center',
    },

    backIconAlign: {
        margin: '0 1rem',
    },
    QuoteShippingMainSubContainer: {
        height: 'calc(100vh - 60px)',
        overflow: 'auto',
    },
}));

const ShippingQuoteEstimatorContainer = () => {
    const classes = useStyles();
    const { history, pathname, query } = useRouter();
    const [senderInfo, setSenderInfo] = useState({});
    const [recipientInfo, setRecipientInfo] = useState({});
    const [packageInfo, setPackageInfo] = useState({});
    const [shipmentRateInfo, setShipmentRateInfo] = useState({});
    const [scrolledToBottom, setScrolledToBottom] = useState(false);
    const { data: HolidayShippingEnabled } = useQuery(
        ['HolidayShippingEnabled'],
        () => isListEnabled('HolidayShipping'),
        {
            refetchOnMount: true,
        }
    );

    const [initialShipmentValues, setInitialShipmentValues] = useState({
        senderZipCode: '',
        recipientZipCode: '',
        weight: '',
        country: 'US',
    });
    const { step } = query;
    console.log({ recipientInfo, senderInfo });
    const divRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleScroll = (e: any) => {
            const bottom =
                e.target.scrollHeight - e.target.scrollTop <=
                e.target.clientHeight + 50;
            if (bottom) {
                setScrolledToBottom(true);
            } else {
                setScrolledToBottom(false);
            }
        };

        const currentDiv = divRef.current;
        if (currentDiv) {
            currentDiv.addEventListener('scroll', handleScroll);
        }

        return () => {
            if (currentDiv) {
                currentDiv.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);
    const getComponentBasedOnRoute = () => {
        switch (step) {
            case 'getEstimator':
                return (
                    <ShippingQuoteEstimator
                        setShipmentRateInfo={setShipmentRateInfo}
                        initialShipmentValues={initialShipmentValues}
                        setInitialShipmentValues={setInitialShipmentValues}
                    />
                );
            case 'shippingRateDelivery':
                return (
                    <ShippingRateDelivery
                        shipmentRateInfo={shipmentRateInfo}
                        initialShipmentValues={initialShipmentValues}
                        bottomShadow={scrolledToBottom}
                        HolidayShippingEnabled={HolidayShippingEnabled}
                    />
                );
            default:
                return null;
        }
    };
    const goBack = () => {
        let search;
        switch (step) {
            case 'getEstimator':
                search = '';
                break;
            case 'shippingRateDelivery':
                search = 'getEstimator';
                break;
            default:
                search = '';
        }
        if (search) {
            history.push({
                pathname: ROUTES.getQuoteShippingInformation,
                search: search ? `step=${search}` : '',
            });
        } else {
            history.push({ pathname: ROUTES.shippingServices });
        }
    };

    return (
        <div className={classes.QuoteShippingContainer}>
            <div className={classes.QuoteShippingHeader}>
                <div className={classes.QuoteShippingHeaderImgTextAlign}>
                    <ButtonBase
                        className={classes.backIconAlign}
                        onClick={goBack}
                    >
                        <IconBack />
                    </ButtonBase>
                    <Heading type="h3" size={20}>
                        Delivery rates and estimates
                    </Heading>
                </div>
            </div>
            <div className={classes.QuoteShippingMainSubContainer} ref={divRef}>
                {getComponentBasedOnRoute()}
            </div>
        </div>
    );
};

export default ShippingQuoteEstimatorContainer;
